module.exports = __webpack_public_path__ + "static/media/button-diamanten.0a159451.svg";